<!-- location-cascade-dropdown-component.html - 修正版本 -->
<ng-container [formGroup]="form">
  <!-- Country Dropdown/MultiSelect -->
  <div *ngIf="isCountryVisible()" [class]="cssClasses">
    <label [class]="labelClasses">
      <span *ngIf="isFieldRequired('country')" class="requiredStart">*</span>
      {{ countryLabel }}
    </label>
    <div [class]="valueClasses">
      <!-- MultiSelect 版本 -->
      <p-multiSelect
        *ngIf="useMultiSelectForCountry"
        formControlName="country"
        optionLabel="label"
        optionValue="value"
        [options]="countryOptions"
        [showClear]="showClear"
        [filter]="enableFilter"
        [placeholder]="countryPlaceholder"
        display="chip"
        styleClass="p-text-left"
        (onChange)="onCountryChange($event.value)"
      >
      </p-multiSelect>

      <!-- 單選 Dropdown 版本 -->
      <p-dropdown
        *ngIf="!useMultiSelectForCountry"
        formControlName="country"
        optionLabel="label"
        optionValue="value"
        [options]="countryOptions"
        [showClear]="showClear"
        [filter]="enableFilter"
        [placeholder]="countryPlaceholder"
        styleClass="p-text-left"
        (onChange)="onCountryChange($event.value)"
      >
      </p-dropdown>

      <!-- 驗證錯誤訊息 -->
      <div *ngIf="shouldShowFieldError('country')">
        <small class="p-invalid"
          >{{ 'Common.Button.Required' | translate }}</small
        >
      </div>
    </div>
  </div>

  <!-- City Dropdown/MultiSelect -->
  <div *ngIf="isCityVisible()" [class]="cssClasses">
    <label [class]="labelClasses">
      <span *ngIf="isFieldRequired('city')" class="requiredStart">*</span>
      {{ cityLabel }}
    </label>
    <div [class]="valueClasses">
      <!-- MultiSelect 版本 -->
      <p-multiSelect
        *ngIf="useMultiSelectForCity"
        formControlName="city"
        optionLabel="label"
        optionValue="value"
        [options]="cityOptions"
        [showClear]="showClear"
        [filter]="enableFilter"
        [placeholder]="cityPlaceholder"
        display="chip"
        styleClass="p-text-left"
        (onChange)="onCityChange($event.value)"
        [virtualScroll]="virtualScroll"
        [itemSize]="itemSize"
      >
      </p-multiSelect>

      <!-- 單選 Dropdown 版本 -->
      <p-dropdown
        *ngIf="!useMultiSelectForCity"
        formControlName="city"
        optionLabel="label"
        optionValue="value"
        [options]="cityOptions"
        [showClear]="showClear"
        [filter]="enableFilter"
        [placeholder]="cityPlaceholder"
        styleClass="p-text-left"
        (onChange)="onCityChange($event.value)"
        [virtualScroll]="virtualScroll"
        [itemSize]="itemSize"
      >
      </p-dropdown>

      <!-- 驗證錯誤訊息 -->
      <div *ngIf="shouldShowFieldError('city')">
        <small class="p-invalid"
          >{{ 'Common.Button.Required' | translate }}</small
        >
      </div>
    </div>
  </div>

  <!-- Area Dropdown/MultiSelect -->
  <div *ngIf="isAreaVisible()" [class]="cssClasses">
    <label [class]="labelClasses">
      <span *ngIf="isFieldRequired('area')" class="requiredStart">*</span>
      {{ areaLabel }}
    </label>
    <div [class]="valueClasses">
      <!-- MultiSelect 版本 -->
      <p-multiSelect
        *ngIf="useMultiSelectForArea"
        formControlName="area"
        optionLabel="label"
        optionValue="value"
        [options]="areaOptions"
        [showClear]="showClear"
        [filter]="enableFilter"
        [placeholder]="areaPlaceholder"
        display="chip"
        styleClass="p-text-left"
        (onChange)="onAreaChange($event.value)"
      >
      </p-multiSelect>

      <!-- 單選 Dropdown 版本 -->
      <p-dropdown
        *ngIf="!useMultiSelectForArea"
        formControlName="area"
        optionLabel="label"
        optionValue="value"
        [options]="areaOptions"
        [showClear]="showClear"
        [filter]="enableFilter"
        [placeholder]="areaPlaceholder"
        styleClass="p-text-left"
        (onChange)="onAreaChange($event.value)"
      >
      </p-dropdown>

      <!-- 驗證錯誤訊息 -->
      <div *ngIf="shouldShowFieldError('area')">
        <small class="p-invalid"
          >{{ 'Common.Button.Required' | translate }}</small
        >
      </div>
    </div>
  </div>

  <!-- Express Area Dropdown/MultiSelect -->
  <div *ngIf="isExpressAreaVisible()" [class]="cssClasses">
    <label [class]="labelClasses">
      <span *ngIf="isFieldRequired('expressArea')" class="requiredStart">*</span>
      {{ expressAreaLabel }}
    </label>
    <div [class]="valueClasses">
      <!-- MultiSelect 版本 -->
      <p-multiSelect
        *ngIf="useMultiSelectForExpressArea"
        formControlName="expressArea"
        optionLabel="label"
        optionValue="value"
        [options]="expressAreaOptions"
        [showClear]="showClear"
        [filter]="enableFilter"
        [placeholder]="expressAreaPlaceholder"
        display="chip"
        styleClass="p-text-left"
        (onChange)="onExpressAreaChange($event.value)"
      >
      </p-multiSelect>

      <!-- 單選 Dropdown 版本 -->
      <p-dropdown
        *ngIf="!useMultiSelectForExpressArea"
        formControlName="expressArea"
        optionLabel="label"
        optionValue="value"
        [options]="expressAreaOptions"
        [showClear]="showClear"
        [filter]="enableFilter"
        [placeholder]="expressAreaPlaceholder"
        styleClass="p-text-left"
        (onChange)="onExpressAreaChange($event.value)"
      >
      </p-dropdown>

      <!-- 驗證錯誤訊息 -->
      <div *ngIf="shouldShowFieldError('expressArea')">
        <small class="p-invalid"
          >{{ 'Common.Button.Required' | translate }}</small
        >
      </div>
    </div>
  </div>

  <!-- District Dropdown/MultiSelect -->
  <div *ngIf="isDistrictVisible()" [class]="cssClasses">
    <label [class]="labelClasses">
      <span *ngIf="isFieldRequired('district')" class="requiredStart">*</span>
      {{ districtLabel }}
    </label>
    <div [class]="valueClasses">
      <!-- MultiSelect 版本 -->
      <p-multiSelect
        *ngIf="useMultiSelectForDistrict"
        formControlName="district"
        optionLabel="label"
        optionValue="value"
        [options]="districtOptions"
        [showClear]="showClear"
        [filter]="enableFilter"
        [placeholder]="districtPlaceholder"
        display="chip"
        styleClass="p-text-left"
        (onChange)="onDistrictChange($event.value)"
      >
      </p-multiSelect>

      <!-- 單選 Dropdown 版本 -->
      <p-dropdown
        *ngIf="!useMultiSelectForDistrict"
        formControlName="district"
        optionLabel="label"
        optionValue="value"
        [options]="districtOptions"
        [showClear]="showClear"
        [filter]="enableFilter"
        [placeholder]="districtPlaceholder"
        styleClass="p-text-left"
        (onChange)="onDistrictChange($event.value)"
      >
      </p-dropdown>

      <!-- 驗證錯誤訊息 -->
      <div *ngIf="shouldShowFieldError('district')">
        <small class="p-invalid"
          >{{ 'Common.Button.Required' | translate }}</small
        >
      </div>
    </div>
  </div>
</ng-container>
